import {useToastStore} from '../state/toast.js'

const SW_URL = '/service-worker.js'

let registered = false

/**
 * Register the app service worker. Idempotent — repeated calls are no-ops.
 * Skipped when MOCK_API is true (MSW owns the SW slot in dev) and in
 * non-browser environments.
 *
 * @return {Promise<ServiceWorkerRegistration|null>}
 */
export async function registerServiceWorker() {
    if (registered)
        return null
    registered = true

    if (typeof window === 'undefined' || !('serviceWorker' in navigator))
        return null

    if (process.env.MOCK_API === 'true')
        return null

    try {
        const reg = await navigator.serviceWorker.register(SW_URL)
        wireUpdateNotices(reg)
        return reg
    } catch (err) {
        console.warn('[sw] registration failed', err)
        return null
    }
}

/**
 * Surface a "Reload to update" toast when a new SW is ready or a new SW
 * has taken control.
 * @param {ServiceWorkerRegistration} reg
 */
function wireUpdateNotices(reg) {
    let toastShown = false
    const showUpdate = () => {
        if (toastShown)
            return
        toastShown = true
        useToastStore.getState().pushToast({
            title: 'Update ready',
            body: 'A new version is available.',
            variant: 'update',
            action: {label: 'Reload', onClick: () => window.location.reload()}
        })
    }

    if (reg.waiting && navigator.serviceWorker.controller)
        showUpdate()

    reg.addEventListener('updatefound', () => {
        const installing = reg.installing
        if (!installing)
            return
        installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller)
                showUpdate()
        })
    })

    let reloading = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloading)
            return
        reloading = true
        showUpdate()
    })
}
